module.exports = ".button-new-user {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 30px; }\n"